{
  "journalAudit.action.lifecycle.export_retried": "Export d’une suppression relancé",
  "journalAudit.action.lifecycle.export_retry_denied": "Relance d’un export refusée",
  "v8e.code.IDEMPOTENCY_KEY_CONFLICT": "Cette création a déjà été envoyée avec d’autres valeurs : rouvrez le dialogue.",
  "v8e.code.LIFECYCLE_ALREADY_SCHEDULED": "Une suppression de ce projet est déjà programmée.",
  "v8e.code.LIFECYCLE_CONFIRMATION_MISMATCH": "Le nom retapé ne correspond pas au nom du projet.",
  "v8e.code.LIFECYCLE_DELAY_OUT_OF_RANGE": "Le délai avant purge est hors des bornes de la plateforme.",
  "v8e.code.LIFECYCLE_EXPORT_NOT_READY": "L’archive d’export n’est pas prête.",
  "v8e.code.LIFECYCLE_REASON_REQUIRED": "Le motif doit comporter de 10 à 1000 caractères.",
  "v8e.code.LIFECYCLE_REQUEST_CLOSED": "Cette demande est close : plus rien à annuler ni à relancer.",
  "v8e.code.PLATFORM_ADMIN_REQUIRED": "Ce geste est réservé à l’administration de la plateforme.",
  "v8e.code.STORAGE_UNAVAILABLE": "Le magasin des archives est indisponible : réessayez plus tard.",
  "v8e.code.TEMPLATE_NOT_FOUND": "Ce modèle est inconnu dans l’organisation.",
  "v8e.code.TEMPLATE_NOT_PUBLISHED": "Ce modèle n’est pas publié.",
  "v8e.code.V8E_EXPORT_NON_EN_ECHEC": "L’export n’est pas en échec : rien à relancer.",
  "v8e.code.WORKSPACE_DELETION_PENDING": "Une suppression est programmée : annulez-la d’abord.",
  "v8e.code.WORKSPACE_NOT_ARCHIVED": "Ce projet n’est pas archivé.",
  "v8e.projets.annuler.deja_purgee": "Le projet est déjà purgé : rien à annuler.",
  "v8e.projets.annuler.export_conserve": "L’archive d’export est conservée jusqu’à son échéance.",
  "v8e.projets.annuler.motif": "Motif (facultatif, 10 caractères au moins)",
  "v8e.projets.annuler.motif_longueur": "Le motif doit comporter 10 caractères au moins.",
  "v8e.projets.annuler.projet": "Projet : {{nom}}",
  "v8e.projets.annuler.retabli": "Le projet est rétabli dans son état d’avant la demande.",
  "v8e.projets.annuler.retour": "Revenir à la demande",
  "v8e.projets.annuler.verbe": "Confirmer l’annulation",
  "v8e.projets.archiver.desarchivable": "Il peut être désarchivé à tout moment.",
  "v8e.projets.archiver.donnees_conservees": "Ses données et son journal sont conservés.",
  "v8e.projets.archiver.lecture_seule": "Le projet passe en lecture seule.",
  "v8e.projets.archiver.motif": "Motif (facultatif, 500 caractères au plus)",
  "v8e.projets.archiver.projet": "Projet : {{nom}}",
  "v8e.projets.archiver.verbe": "Archiver",
  "v8e.projets.creer.creer": "Créer le projet",
  "v8e.projets.creer.description": "Description (facultative)",
  "v8e.projets.creer.modele": "Modèle d’espace",
  "v8e.projets.creer.modele_aucun": "Aucun modèle n’est encore proposé par l’organisation : le projet reçoit le modèle par défaut.",
  "v8e.projets.creer.nom": "Nom du projet",
  "v8e.projets.creer.nom_longueur": "Le nom doit comporter de 3 à 255 caractères.",
  "v8e.projets.creer.plus_tard": "Créer et lancer plus tard",
  "v8e.projets.creer.programme": "Programme",
  "v8e.projets.creer.proposer_modele": "Proposer un modèle dans le catalogue",
  "v8e.projets.creer.propriete": "Vous en devenez propriétaire ; la propriété se transfère ensuite à un membre.",
  "v8e.projets.creer.sans_programme": "Aucun programme",
  "v8e.projets.desarchiver.consequence_ecriture": "Le projet redevient modifiable par ses membres.",
  "v8e.projets.desarchiver.consequence_journal": "Le désarchivage est écrit au journal de l’organisation.",
  "v8e.projets.desarchiver.fait": "Projet désarchivé.",
  "v8e.projets.desarchiver.titre": "Désarchiver « {{nom}} » ?",
  "v8e.projets.desarchiver.verbe": "Désarchiver",
  "v8e.projets.dialogue.projet": "le projet",
  "v8e.projets.etat.actif": "Actif",
  "v8e.projets.etat.archive": "Archivé",
  "v8e.projets.etat.lancement_inacheve": "Lancement à terminer",
  "v8e.projets.etat.suppression_programmee": "Suppression programmée",
  "v8e.projets.fiche.adresse_invalide": "Adresse invalide : le numéro de la demande est un entier.",
  "v8e.projets.fiche.annulee_par": "Annulée par",
  "v8e.projets.fiche.annuler": "Annuler la suppression",
  "v8e.projets.fiche.conserve": "Sont conservés : la preuve de la purge et le journal d’audit.",
  "v8e.projets.fiche.demandee_par": "Demandée par",
  "v8e.projets.fiche.echeance": "Purge après le {{date}}.",
  "v8e.projets.fiche.empreinte": "Empreinte SHA-256 : {{sha}}",
  "v8e.projets.fiche.empreinte_differente": "Empreinte du téléchargement DIFFÉRENTE de celle de la demande : ne vous fiez pas à ce fichier.",
  "v8e.projets.fiche.empreinte_identique": "Empreinte du téléchargement identique à celle de la demande.",
  "v8e.projets.fiche.etat": "État",
  "v8e.projets.fiche.etat_demande.absorbee_par_la_suppression_de_l_organisation": "Absorbée par la suppression de l’organisation",
  "v8e.projets.fiche.etat_demande.annulee_par_avec_motif": "Annulée",
  "v8e.projets.fiche.etat_demande.export_en_echec_purge_suspendue": "Programmée — export en échec, purge suspendue",
  "v8e.projets.fiche.etat_demande.export_en_preparation": "Programmée — export en préparation",
  "v8e.projets.fiche.etat_demande.export_pret": "Programmée — export prêt",
  "v8e.projets.fiche.etat_demande.purge_en_echec_plateforme_alertee": "Purge en échec — la plateforme est alertée",
  "v8e.projets.fiche.etat_demande.purge_engagee": "Purge engagée",
  "v8e.projets.fiche.etat_demande.purgee_rapport_et_recu": "Purgée — rapport et reçu conservés",
  "v8e.projets.fiche.export": "Export",
  "v8e.projets.fiche.export_etat.en_echec": "Export en échec : la purge est suspendue tant qu’il n’est pas prêt.",
  "v8e.projets.fiche.export_etat.en_preparation": "Export en préparation.",
  "v8e.projets.fiche.export_etat.expire": "Archive expirée.",
  "v8e.projets.fiche.export_etat.pret": "Export prêt.",
  "v8e.projets.fiche.motif": "Motif",
  "v8e.projets.fiche.perimetre": "Seront purgés : le projet « {{projet}} », {{elements}} élément(s), {{documents}} document(s), {{depots}} dépôt(s).",
  "v8e.projets.fiche.projet": "Projet",
  "v8e.projets.fiche.purge_engagee": "Purge engagée : la suppression ne s’annule plus.",
  "v8e.projets.fiche.quoi": "la demande de suppression",
  "v8e.projets.fiche.relance_faite": "Export relancé : il est de nouveau en préparation.",
  "v8e.projets.fiche.relancer": "Relancer l’export",
  "v8e.projets.fiche.relances": "Relances de l’export",
  "v8e.projets.fiche.retour": "Retour aux projets",
  "v8e.projets.fiche.telecharger": "Télécharger l’export",
  "v8e.projets.filtre.actif": "Actifs",
  "v8e.projets.filtre.archive": "Archivés",
  "v8e.projets.filtre.lancement_inacheve": "Lancement à terminer",
  "v8e.projets.filtre.sans_programme": "Sans programme",
  "v8e.projets.filtre.suppression_programmee": "Suppression programmée",
  "v8e.projets.filtre.tous": "Tous les états",
  "v8e.projets.filtre.tous_programmes": "Tous les programmes",
  "v8e.projets.liste.actions": "Actions sur {{nom}}",
  "v8e.projets.liste.archiver": "Archiver",
  "v8e.projets.liste.aucun_resultat": "Aucun projet ne répond à la recherche ou aux filtres.",
  "v8e.projets.liste.creer": "Créer un projet",
  "v8e.projets.liste.desarchiver": "Désarchiver",
  "v8e.projets.liste.filtre_etat": "État du projet",
  "v8e.projets.liste.filtre_programme": "Programme",
  "v8e.projets.liste.precedente": "Page précédente",
  "v8e.projets.liste.proprietaire": "Propriétaire : {{qui}}",
  "v8e.projets.liste.quoi": "la liste des projets",
  "v8e.projets.liste.raison.archiver.suppression_programmee": "Suppression programmée : le projet est déjà en lecture seule.",
  "v8e.projets.liste.raison.desarchiver.suppression_programmee": "Suppression programmée : annulez-la d’abord pour désarchiver.",
  "v8e.projets.liste.raison.etat": "Indisponible dans l’état actuel du projet, ou réservé à l’administration de l’organisation.",
  "v8e.projets.liste.raison.rattacher.archive": "Projet archivé : désarchivez-le d’abord.",
  "v8e.projets.liste.raison.rattacher.suppression_programmee": "Suppression programmée : le projet est en lecture seule.",
  "v8e.projets.liste.raison.renommer.archive": "Projet archivé : désarchivez-le d’abord.",
  "v8e.projets.liste.raison.renommer.suppression_programmee": "Suppression programmée : le projet est en lecture seule.",
  "v8e.projets.liste.raison.supprimer.archive": "Projet archivé : désarchivez-le d’abord.",
  "v8e.projets.liste.raison.supprimer.suppression_programmee": "Une suppression est déjà programmée.",
  "v8e.projets.liste.rattacher": "Rattacher à un programme",
  "v8e.projets.liste.recherche": "Rechercher (nom ou description, 2 caractères au moins)",
  "v8e.projets.liste.renommer": "Renommer",
  "v8e.projets.liste.suivante": "Page suivante",
  "v8e.projets.liste.supprimer": "Programmer la suppression",
  "v8e.projets.liste.total": "{{n}} projet(s)",
  "v8e.projets.liste.vide": "L’organisation n’a encore aucun projet.",
  "v8e.projets.onglet.lancements": "Lancements à terminer",
  "v8e.projets.onglet.projets": "Projets",
  "v8e.projets.onglet.suppressions": "Suppressions programmées",
  "v8e.projets.panneau.aucun": "Choisissez un projet dans la liste pour le voir ici.",
  "v8e.projets.panneau.details": "Détails",
  "v8e.projets.panneau.etat": "État",
  "v8e.projets.panneau.lecture_seule": "Projet archivé : lecture seule.",
  "v8e.projets.panneau.membres": "Membres",
  "v8e.projets.panneau.ouvrir": "Ouvrir le projet",
  "v8e.projets.panneau.programme": "Programme",
  "v8e.projets.panneau.proprietaires": "Propriétaires",
  "v8e.projets.panneau.sans_programme": "Sans programme",
  "v8e.projets.panneau.sollicitee": "Suppression sollicitée par le propriétaire ({{qui}}).",
  "v8e.projets.panneau.suppression": "Suppression programmée : purge après le {{date}}.",
  "v8e.projets.panneau.voir_demande": "Voir la demande",
  "v8e.projets.renommer.verbe": "Renommer",
  "v8e.projets.suppressions.etat.cancelled": "Annulée",
  "v8e.projets.suppressions.etat.en_echec": "Programmée, export en échec (purge suspendue)",
  "v8e.projets.suppressions.etat.en_preparation": "Programmée, export en préparation",
  "v8e.projets.suppressions.etat.expire": "Programmée, archive expirée",
  "v8e.projets.suppressions.etat.pret": "Programmée, export prêt",
  "v8e.projets.suppressions.etat.purged": "Purgée",
  "v8e.projets.suppressions.etat.sollicitee": "Sollicitée par le propriétaire",
  "v8e.projets.suppressions.etat.superseded": "Absorbée",
  "v8e.projets.suppressions.purge_le": "purge après le {{date}}",
  "v8e.projets.suppressions.quoi": "les suppressions programmées",
  "v8e.projets.suppressions.vide": "Aucune suppression de projet programmée.",
  "v8e.projets.suppressions.voir": "Voir la demande pour {{nom}}",
  "v8e.projets.supprimer.annulable": "La suppression reste annulable jusqu’à ce que la purge soit engagée.",
  "v8e.projets.supprimer.delai": "Délai avant purge, en jours ({{min}} à {{max}})",
  "v8e.projets.supprimer.delai_hors_bornes": "Délai hors des bornes de la plateforme.",
  "v8e.projets.supprimer.export_d_abord": "Un export complet est produit d’abord, téléchargeable par l’administration.",
  "v8e.projets.supprimer.lecture_seule": "Le projet passe aussitôt en lecture seule.",
  "v8e.projets.supprimer.missions": "Ses missions en cours sont arrêtées.",
  "v8e.projets.supprimer.motif": "Motif (10 à 1000 caractères)",
  "v8e.projets.supprimer.motif_longueur": "Le motif doit comporter de 10 à 1000 caractères.",
  "v8e.projets.supprimer.ne_correspond_pas": "Le nom ne correspond pas.",
  "v8e.projets.supprimer.projet": "Projet : {{nom}}",
  "v8e.projets.supprimer.purge": "La purge a lieu après le délai, seulement si l’export est prêt.",
  "v8e.projets.supprimer.retaper": "Retapez le nom du projet : {{nom}}",
  "v8e.projets.supprimer.verbe": "Programmer la suppression"
}
